import Button from 'components/Form/Button';
import { FormSeparator } from 'components/Form/Core/styled';
import { CoreContext } from 'context/CoreContext';
import moment from 'moment';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Update, UpdateParecer } from 'services/banking';
import { TableInfo, Title, Touch } from 'ui/styled';
import { theme } from 'ui/theme-color';
import { capitalize, parseStrapiImage } from 'utils';
import { parseCurrency } from 'utils/parsers';
import FormCore from '../../Form/Core';
import WrapperTwoCol from '../WrapperTwoCol';
import ObservationChecklist from './ObservationChecklist';
import {
  AddProposalContainer,
  ButtonsAndInputWrapper,
  CompanyButtonContainer,
  TimelineContainer,
  TimelineContent,
  TimelineItem,
} from './styled';
import { defaultCheckListMessages } from './utils';

export default function BankingCredito({ data, reload, reloadWindow }) {
  const { setModal, user } = useContext(CoreContext);
  const formRef = useRef(null);
  const formRefBureau = useRef(null);
  const formRefToExpire = useRef(null);
  const formRefExpired = useRef(null);
  const formRefParecer = useRef(null);
  const refFormAvalista = useRef(null);
  const [showDocs, setShowDocs] = useState(false);
  const [showParecer, setShowParecer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [observationCheckListItems, setObservationCheckListItems] = useState(
    []
  );

  const close = () => setModal(null);

  const hasAvalista =
    data?.avalista_cpf || data?.avalista_nome || data?.avalista_bureau_score;

  const formProposta = [
    {
      ref: 'valor_venda',
      placeholder: 'Valor Total da Venda (R$)',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_entrada',
      placeholder: 'Valor Entrada (R$)',
      tress: true,
      type: 'money',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_financiamento',
      placeholder: 'Valor Financiado (R$)',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'taxa',
      placeholder: 'Taxa ',
      tress: true,
      type: 'string',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'carencia',
      placeholder: 'Carência (dias)',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'prazo_financiamento',
      placeholder: 'Prazo',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'tac',
      placeholder: 'TAC',
      tress: true,
      type: 'money',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'seguro',
      placeholder: 'Seguro Prestamista',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'seguro_assistencia',
      placeholder: 'Seguro de Assistência',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'tab',
      placeholder: 'TAB',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'iof',
      placeholder: 'IOF',
      tress: true,
      type: 'select',
      required: false,
      disabled: true,
      transparent: false,
    },
    {
      ref: 'valor_parcelas',
      placeholder: 'PMT',
      tress: true,
      type: 'money',
      required: false,
      transparent: false,
      readOnly: true,
      style: {
        backgroundColor: theme.palette.purple.main,
        color: theme.palette.purple.contrastText,
      },
    },
  ];

  const formBureau = [
    {
      ref: 'bureau_score',
      placeholder: 'Score',
      tress: true,
      type: 'number',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'classificacao_julia',
      placeholder: 'Classificação Júlia',
      customWidthCalc: 'calc(100% - 6px) / 1.5',
      type: 'text',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'bacen_vencidos',
      placeholder: 'Total Vencido',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'serasa_restritivos',
      placeholder: 'Valor Negativado',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'bacen_prejuizo',
      placeholder: 'Valor em Prejuízo',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'renda_presumida',
      placeholder: 'Renda Presumida',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'risco_total',
      placeholder: 'Risco Total',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'fatorRiscoSobreRenda',
      placeholder: 'Endividamento',
      tress: true,
      type: 'number',
      disabled: true,
      default: 0,
      transparent: false,
    },
  ];

  const formToExpire = [
    {
      ref: 'days_to_expire_30',
      placeholder: 'Até 30 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_31_60',
      placeholder: '31 a 60 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_61_90',
      placeholder: '61 a 90 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_91_180',
      placeholder: '91 a 180 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'days_to_expire_181_360',
      placeholder: '181 a 360 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'more_360_days_to_expire',
      placeholder: 'Mais de 360 dias',
      type: 'text',
      tress: true,
      disabled: true,
      transparent: false,
    },
  ];

  const formExpired = [
    {
      ref: 'expired_15_30',
      placeholder: 'até 30 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_31_60',
      placeholder: '31 a 60 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_61_90',
      placeholder: '61 a 90 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_91_180',
      placeholder: '91 a 180 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'expired_181_360',
      placeholder: '181 a 360 dias',
      tress: true,
      type: 'money',
      disabled: true,
      transparent: false,
    },
    {
      ref: 'more_360_days_expired',
      placeholder: 'Mais de 360 dias',
      tress: true,
      type: 'text',
      disabled: true,
      transparent: false,
    },
  ];

  const formParecer = [
    {
      ref: 'obs',
      placeholder: 'Observações',
      full: true,
      required: true,
      disabled: false,
      maxRows: 4,
      multiline: true,
      height: 100,
    },
  ];

  const formAvalista = [
    {
      ref: 'avalista_bureau_score',
      placeholder: 'Score Avalista',
      type: 'string',
      required: false,
      disabled: true,
      tress: true,
      transparent: false,
    },
    {
      ref: 'avalista_nome',
      placeholder: 'Avalista',
      type: 'string',
      required: false,
      disabled: true,
      tress: true,
      transparent: false,
    },
    {
      ref: 'avalista_cpf',
      placeholder: 'CPF Avalista',
      type: 'string',
      required: false,
      disabled: true,
      tress: true,
      transparent: false,
    },
  ];

  const validDocs = useMemo(() => {
    const docMap = [
      {
        label: 'Doc. Identificação Cliente',
        file: data?.documento_identificacao,
      },
      { label: 'Comp. Renda Cliente', file: data?.comprovante_renda },
      { label: 'Doc. Identificação Avalista', file: data?.avalista_doc_ident },
      { label: 'Comp. Renda Avalista', file: data?.avalista_comp_renda },
      { label: 'Doc. Bureau', file: data?.documento_bureau },
    ];
    return docMap
      .map((item) => {
        const file = Array.isArray(item.file) ? item.file[0] : item.file;
        const parsedUrl = parseStrapiImage(file?.url);
        return {
          label: item.label,
          name: file?.name || 'Visualizar Arquivo',
          url: parsedUrl,
          hasFile: !!file && !!parsedUrl,
        };
      })
      .filter((doc) => doc.hasFile);
  }, [data]);

  const aprova = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...data?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: form.obs,
          origem: 'Crédito',
        },
      ];
      const payload = {
        status: 'aprovado',
        parecer: newParecer,
        proposta_financeira: data.id_proposal,
        proposta_bancaria: data.proposta_financeira.propostas_banco[0].id,
      };
      const result = await UpdateParecer({ data: payload }, data.id);
      if (result.status !== 200) {
        throw new Error(result?.error?.message);
      }
      if (result?.message !== 'ok') {
        toast.error(result?.message);
        close();
        reload?.();
      } else {
        toast.success('Registro salvo com sucesso!');
        close();
        reload?.();
      }
    } catch (err) {
      toast.error(err?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  const reprova = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();
      if (!form) {
        return;
      }
      const newParecer = [
        ...data?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: `MOTIVO REPROVAÇÃO: ${form.obs}`,
          origem: 'Crédito',
        },
      ];
      const payload = {
        status: 'recusado',
        parecer: newParecer,
        proposta_financeira: data.id_proposal,
        proposta_bancaria: data.proposta_financeira.propostas_banco[0].id,
      };
      const result = await UpdateParecer({ data: payload }, data.id);
      if (result.status !== 200) {
        throw new Error('Erro ao salvar');
      }
      toast.success('Registro salvo com sucesso!', {
        onClose: () => reloadWindow(),
      });
      close();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  const reanalisa = async () => {
    try {
      setLoading(true);
      const form = await formRefParecer.current.getForm?.();

      // verifica se a checklist tem apenas itens do modal "Documentos" ou se é necessário reenviar para "Negócios"
      const documentCheckboxFields = ['incluir_avalista', 'solicitar_renda'];
      const isDocument = observationCheckListItems.every((field) =>
        documentCheckboxFields.includes(field)
      );

      const payloadStatus = isDocument ? 'documento' : 'negocio';

      if (!form) {
        return;
      }

      const newParecer = [
        ...data?.parecer,
        {
          usuario: user.id,
          data: new Date(),
          message: form.obs,
          origem: 'Crédito',
        },
      ];

      const payload = {
        status: payloadStatus,
        parecer: newParecer,
        observationCheckList: observationCheckListItems,
      };

      await Update({ data: payload }, data.id);

      toast.success('Registro salvo com sucesso!', {
        onClose: () => reloadWindow(),
      });
      close();
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!data || !formRef.current?.setItem) {
      return;
    }
    formRef.current.setItem(data.value, 'valor_venda');
    formRef.current.setItem(
      data?.proposta_financeira?.propostas_banco[0]?.valor_entrada,
      'valor_entrada'
    );
    formRef.current.setItem(
      parseCurrency(
        data?.proposta_financeira?.informacoes_projeto?.custo_total_projeto -
          data?.proposta_financeira?.propostas_banco[0]?.valor_entrada
      ),
      'valor_financiamento'
    );
    formRef.current.setItem(
      parseCurrency(
        data?.proposta_financeira?.propostas_banco[0]?.valor_parcelas
      ),
      'valor_parcelas'
    );
    if (data?.proposta_financeira?.propostas_banco[0]?.data) {
      const date = new Date(data.proposta_financeira.propostas_banco[0].data);
      if (!isNaN(date.getTime())) {
        formRef.current.setItem(date.toISOString().split('T')[0], 'data');
      }
    }
    formRef.current.setItem(
      String(
        data?.proposta_financeira?.propostas_banco[0]?.prazo_financiamento
      ),
      'prazo_financiamento'
    );

    formRef.current.setItem(data?.taxa, 'taxa');
    formRef.current.setItem(
      data?.proposta_financeira?.propostas_banco[0]?.carencia,
      'carencia'
    );
    formRef.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].iof),
      'iof'
    );
    formRef.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].seguro),
      'seguro'
    );
    formRef.current.setItem(
      parseCurrency(
        data?.proposta_financeira.propostas_banco[0].seguro_assistencia
      ),
      'seguro_assistencia'
    );
    formRef.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].tab),
      'tab'
    );
    formRef.current.setItem(
      parseCurrency(data?.proposta_financeira.propostas_banco[0].tac),
      'tac'
    );

    // #region == Avalista ==
    refFormAvalista.current?.setItem(data?.avalista_nome, 'avalista_nome');
    refFormAvalista.current?.setItem(data?.avalista_cpf, 'avalista_cpf');
    refFormAvalista.current?.setItem(
      data?.avalista_bureau_score,
      'avalista_bureau_score'
    );
    // #endregion

    // #region == Bureau ==
    formRefBureau.current.setItem(
      data?.crivo_payload?.bureau_score,
      'bureau_score'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.client_profile,
      'classificacao_julia'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.serasa_restritivos,
      'serasa_restritivos'
    );
    formRefBureau.current.setItem(
      parseCurrency(data?.crivo_payload?.bacen_prejuizo),
      'bacen_prejuizo'
    );
    formRefBureau.current.setItem(
      parseCurrency(data?.crivo_payload?.renda_presumida),
      'renda_presumida'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.risco_total,
      'risco_total'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.fatorRiscoSobreRenda,
      'fatorRiscoSobreRenda'
    );
    formRefBureau.current.setItem(
      data?.crivo_payload?.bacen_vencidos,
      'bacen_vencidos'
    );
    // #endregion

    // #region == To Expire ==
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_30),
      'days_to_expire_30'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_31_60),
      'days_to_expire_31_60'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_61_90),
      'days_to_expire_61_90'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_91_180),
      'days_to_expire_91_180'
    );
    formRefToExpire?.current?.setItem(
      parseCurrency(data?.crivo_payload?.days_to_expire_181_360),
      'days_to_expire_181_360'
    );
    formRefToExpire?.current?.setItem(
      data?.crivo_payload?.more_360_days_to_expire,
      'more_360_days_to_expire'
    );
    // #endregion

    //#region == Expired ==
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_15_30,
      'expired_15_30'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_31_60,
      'expired_31_60'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_61_90,
      'expired_61_90'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.expired_91_180,
      'expired_91_180'
    );
    formRefExpired?.current?.setItem(
      parseCurrency(data?.crivo_payload?.expired_181_360),
      'expired_181_360'
    );
    formRefExpired?.current?.setItem(
      data?.crivo_payload?.more_360_days_expired,
      'more_360_days_expired'
    );
    //#endregion
  }, [data]);

  const pareceresInvertidos = useMemo(() => {
    return data?.parecer ? [...data.parecer].reverse() : [];
  }, [data?.parecer]);
  if (!data) {
    return null;
  }

  return (
    <WrapperTwoCol
      onClose={close}
      title={'Crédito'}
      children={
        <AddProposalContainer>
          <FormCore ref={formRefBureau} formItems={formBureau} />
          <FormSeparator />

          <Title small>A vencer</Title>
          <FormCore ref={formRefToExpire} formItems={formToExpire} />
          <FormSeparator />

          <Title small>Vencido</Title>
          <FormCore ref={formRefExpired} formItems={formExpired} />
          <FormSeparator />

          {hasAvalista && (
            <>
              <Title small>Avalista</Title>
              <FormCore ref={refFormAvalista} formItems={formAvalista} />
              <FormSeparator />
            </>
          )}
        </AddProposalContainer>
      }
      titleColumn1="Bureau"
      width="70vw"
      children2={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
          }}
        >
          <AddProposalContainer>
            <FormCore ref={formRef} formItems={formProposta} />
          </AddProposalContainer>

          <FormSeparator />
          <div style={{ display: 'grid', gap: '1rem', height: '100%' }}>
            <div>
              <Touch
                onClick={() => setShowDocs(!showDocs)}
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  background: '#f4f4f4',
                  padding: '10px',
                  borderRadius: '4px',
                }}
              >
                <Title nomargin small>
                  Documentos: ({validDocs.length})
                </Title>
                <span
                  style={{
                    transition: '0.3s',
                    transform: showDocs ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                >
                  ▼
                </span>
              </Touch>
              {showDocs && (
                <div
                  style={{
                    padding: '15px',
                    background: '#fff',
                    border: '1px solid #eee',
                    borderRadius: '0 0 5px 5px',
                  }}
                >
                  {validDocs.map((doc, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginBottom: '10px',
                        alignItems: 'center',
                        borderBottom: '1px solid #f9f9f9',
                      }}
                    >
                      <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                        {doc.label}:
                      </span>
                      <Touch onClick={() => window.open(doc.url, 'new')}>
                        <TableInfo style={{ color: 'blue', margin: 0 }}>
                          {doc.name}
                        </TableInfo>
                      </Touch>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <Touch
              onClick={() => setShowParecer(!showParecer)}
              style={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: '#f4f4f4',
                padding: '10px',
                borderRadius: '4px',
                marginBottom: '16px',
              }}
            >
              <Title nomargin small>
                Parecer: ({data?.parecer.length})
              </Title>
              <span
                style={{
                  transition: '0.3s',
                  transform: showParecer ? 'rotate(180deg)' : 'rotate(0deg)',
                }}
              >
                ▼
              </span>
            </Touch>
            {pareceresInvertidos.length > 0 && showParecer && (
              <TimelineContainer>
                {pareceresInvertidos.map((parecer, idx) => (
                  <TimelineItem key={idx}>
                    <TimelineContent>
                      <div style={{ marginBottom: '4px' }}>
                        <strong style={{ color: '#2d3748', fontSize: '14px' }}>
                          {capitalize(parecer.usuario.username)}
                        </strong>
                        <span
                          style={{
                            color: '#718096',
                            fontSize: '12px',
                            marginLeft: '8px',
                          }}
                        >
                          {moment(parecer.data).format('DD/MM/YYYY HH:mm')} - (
                          {parecer.origem})
                        </span>
                      </div>
                      <span
                        style={{
                          fontSize: '15px',
                          color: '#4a5568',
                          lineHeight: '1.4',
                        }}
                      >
                        {parecer.message}
                      </span>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </TimelineContainer>
            )}
          </div>
          <ObservationChecklist
            onChange={(items) => {
              if (items?.length) {
                setObservationCheckListItems(items);
                const message = items
                  .map(
                    (item) => `* ${defaultCheckListMessages[item]?.message} \n`
                  )
                  .join('');

                formRefParecer.current.setItem(message ?? ' ', 'obs');
              } else {
                if (!!observationCheckListItems.length)
                  setObservationCheckListItems([]);
                formRefParecer.current.setItem(null, 'obs');
              }
            }}
          />
        </div>
      }
      titleColumn2="Proposta"
      footer={
        <div style={{ display: 'grid', width: '100%' }}>
          <ButtonsAndInputWrapper>
            <FormCore ref={formRefParecer} formItems={formParecer} />
            <CompanyButtonContainer>
              <Button color="secondary" onClick={reprova} nospace>
                {loading ? 'Processando' : 'Reprovar'}
              </Button>
              <Button onClick={reanalisa} color="blue" nospace>
                {loading ? 'Processando' : 'Reanalise'}
              </Button>
              <Button
                onClick={aprova}
                color="green"
                nospace
                disabled={!!observationCheckListItems.length}
              >
                {loading ? 'Processando' : 'Aprovar'}
              </Button>
            </CompanyButtonContainer>
          </ButtonsAndInputWrapper>
        </div>
      }
    />
  );
}
